import { motion } from "framer-motion"
import { forwardRef } from "react"

const PickerAnimator = forwardRef(({ children, onFinish }, ref) => {
  return (
    <motion.div
      ref={ref}
      initial={{ scale: 0.8 }}
      animate={{ scale: 1 }}
      transition={{
        type: "spring",
        stiffness: 100,
        damping: 15
      }}
      onAnimationComplete={onFinish}
      style={{
        position: "relative",
        width: "100%",
        height: "100%"
      }}
    >
      {children}
    </motion.div>
  )
})

PickerAnimator.displayName = "PickerAnimator"

export default PickerAnimator
